export const MIXPANEL_GLOBAL_EVENT_PREFIX = "AOPS";

/**
 * Builds the Mixpanel event name using the same rules as the browser client
 * ({@link initMixpanelClient} / {@link trackEvent}).
 */
export function formatMixpanelEventName(
	event: string,
	appEventPrefix = ""
): string {
	return [MIXPANEL_GLOBAL_EVENT_PREFIX, appEventPrefix, event]
		.filter(Boolean)
		.join(" ");
}
